import { computed } from 'vue';

import tt from '@/i18n/utils/translateText';
import { ECurrency } from '@/constants';

export const useTranslateCurrency = () => {
  const CURRENCY_TRANSLATION = computed((): { [Key in ECurrency]: string } => ({
    [ECurrency.rub]: tt('shared.currency.name.rub'),
    [ECurrency.usd]: tt('shared.currency.name.usd'),
    [ECurrency.eur]: tt('shared.currency.name.eur'),
    [ECurrency.cny]: tt('shared.currency.name.cny'),
    [ECurrency.byn]: tt('shared.currency.name.byn'),
  }));

  const CURRENCY_FULL_TRANSLATION = computed((): { [Key in ECurrency]: string } => ({
    [ECurrency.rub]: tt('shared.currency.fullName.rub'),
    [ECurrency.usd]: tt('shared.currency.fullName.usd'),
    [ECurrency.eur]: tt('shared.currency.name.eur'),
    [ECurrency.cny]: tt('shared.currency.name.cny'),
    [ECurrency.byn]: tt('shared.currency.fullName.byn'),
  }));

  const CURRENCY_SYMBOL_TRANSLATION = computed((): { [Key in ECurrency]: string } => ({
    [ECurrency.rub]: tt('shared.currency.symbol.rub'),
    [ECurrency.usd]: tt('shared.currency.symbol.usd'),
    [ECurrency.eur]: tt('shared.currency.symbol.eur'),
    [ECurrency.cny]: tt('shared.currency.symbol.cny'),
    [ECurrency.byn]: tt('shared.currency.symbol.byn'),
  }));

  const getCurrencySymbol = (currency: ECurrency | null | undefined) => (currency
    ? CURRENCY_SYMBOL_TRANSLATION.value[currency]
    : ''
  );

  const getCurrencyName = (currency: ECurrency | null | undefined) => (currency
    ? CURRENCY_TRANSLATION.value[currency]
    : ''
  );

  const getCurrencyFullName = (currency: ECurrency | null | undefined) => (currency
    ? CURRENCY_FULL_TRANSLATION.value[currency]
    : ''
  );

  const getCurrencyNameWithSymbol = (currency: ECurrency | null | undefined) => (currency
    ? `${CURRENCY_TRANSLATION.value[currency]}, ${CURRENCY_SYMBOL_TRANSLATION.value[currency]}`
    : ''
  );

  return {
    getCurrencySymbol,
    getCurrencyName,
    getCurrencyFullName,
    getCurrencyNameWithSymbol,
  };
};
